import { Component } from '@angular/core';

@Component({
  selector: 'auth-app',
  template: `<router-outlet></router-outlet>`,
})

export class AuthComponent {
  constructor() {}
}